export default __webpack_public_path__ + "static/media/store_sign_street_original.ca0e4e2b.jpg";